"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesIconButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("./utils");
const FavoritesIconButton = exports.FavoritesIconButton = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['desktopSize'])
})(({
  desktopSize,
  theme
}) => ({
  '&:disabled .outlinedIcon': {
    color: theme.palette.grey[400]
  },
  [theme.breakpoints.up('sm')]: {
    ...(0, _utils.getDesktopSize)(desktopSize)
  }
}));
//# sourceMappingURL=styles.js.map